export default {
    title: 'Install Icons',
    step1: 'Download the description file and click “Allow”.',
    download: 'Download',
    step2: 'Enter Setting Page. Select the description file and click “Install”.',
    setting: 'Enter Setting Page',

    style2_step1: 'Download the description file and click “Allow”.',
    style2_continue: 'Continue',
}